import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import * as $ from 'jquery';


@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.scss']
})
export class PdfPreviewComponent implements OnInit {
  pdf_data: any;

  constructor(public dialogRef: MatDialogRef<PdfPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private domSanitizer: DomSanitizer) {
    console.log(data);
    this.pdf_data = data['pdf'];

  }

  getPdf() {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.pdf_data);
  }

  printIframe() {
    console.log(window.frames);
    let iframe = document.getElementById('printf') as HTMLIFrameElement;
    iframe.focus();
    iframe.contentWindow.print();
  }

  ngOnInit() {
  }

}
